module.exports = __webpack_public_path__ + "img/icon3.7978b1dd.png";